import { AccountUser } from '@travelata-libs/travelata-frontend';
import DepartureCitiesRepository from "@/js/common/Domain/Repository/DepartureCities";
import CountriesRepository from '@/js/common/Domain/Repository/Countries';
import { getPanelList, getCurrentCity } from '@entities/switch-city';
import ResortsRepository from '@/js/common/Domain/Repository/Resorts';
import ResortFactory from '@/js/common/Domain/Factory/Resort';
import HotelsRepository from '@/js/common/Domain/Repository/Hotels';
import eventBus from '@ve/services/eventBus';
import account from '@/js/desktop/components/account';
import Vue, { reactive } from 'vue';
import type { Store } from 'vuex';
import Backbone from 'backbone';
import getStore from '@ve/services/getStore/getStore';
declare let window: any;

import LibSearchFormHost from '../ui/LibSearchFormHost.vue';
import { IMapForSearchFormState } from '@fr/vue/pages/serp/store';

const HOST_ANCHOR_SELECTOR = '#js-lib-search-form-host';

interface SearchControllerLike {
    model: Backbone.Model;
    formSubmit(): void;
}

export interface MountLibSearchFormOptions {
    store?: Store<unknown>;
    controller: SearchControllerLike;
    disabledDestination?: boolean
}

export interface MountLibSearchFormResult {
    unmount(): void;
}

interface LibSearchFormHostExpose {
    validate(): boolean;
}

export function mountLibSearchForm(options: MountLibSearchFormOptions) {
    const { controller } = options;
    const store = options.store ?? getStore();
    const cities = getPanelList();
    const currentCity = getCurrentCity(cities);
    const authData = reactive<{ user: AccountUser | null, accountUrl: string; }>({
        user: null,
        accountUrl: window.appConfig.accountUrl,
    });

    eventBus.$on('authorize', (user: AccountUser) => {
        authData.user = user
    });
    const rootVm = new Vue({
        name: 'LibSearchFormHostRoot',
        store,
        render: (createElement) => createElement(LibSearchFormHost, {
            ref: 'host',
            props: {
                cities,
                currentCity,
                authData,
                disabledDestination: options.disabledDestination,
            },
            on: {
                search: () => onSearch(),

                ['update:modelValue']: (data: IMapForSearchFormState) => {
                    const departureCity = DepartureCitiesRepository.repository.get(data.departureCity.id);
                    let country = CountriesRepository.repository.get(data.countries[0].id);
                    const modelsHotel = HotelsRepository.repository.getHotelsBuild(data.hotels);
                    let resorts = [];
                    if(data.resorts.length) {
                        resorts = data.resorts.map((r) => new ResortFactory({ ...r, country: data.countries[0].id }));
                    }
                    if (data.countries.length && data.countries[0]?.resorts?.length) {
                        ResortsRepository.repository.addCountryResorts(data.countries[0].resorts, data.countries[0].id);
                    }
                    country = CountriesRepository.repository.get(data.countries[0].id);
                    controller.model.get('countries').set('model', new CountriesRepository([country.clone()]), { disabledSetResorts: true });
                    controller.model.get('resorts').set('model', new Backbone.Collection(resorts));
                    controller.model.get('hotels').set('model', modelsHotel);
                    controller.model.get('departureCity').set('model', departureCity);
                    controller.model.get('nightRange').set('model', new Backbone.Model(data.nightRange));
                    controller.model.get('touristGroup').set('model', new Backbone.Model(data.touristGroup));
                    controller.model.get('checkInDateRange').set('model', new Backbone.Model(data.checkInDateRange));
                },
                login: () => {
                    account.topMenuBar.openAuthForm();
                },
                logout: () => {
                    authData.user = null;
                    account.topMenuBar.logout();
                },
                buy: () => {
                    $('.openGeneralLeadForm')?.click();
                }
            },
        }),
    });

    function getHost(): LibSearchFormHostExpose | null {
        return (rootVm.$refs.host as unknown as LibSearchFormHostExpose | undefined) ?? null;
    }

    function onSearch(): void {
        const host = getHost();
        const isFormValid = host ? host.validate() : true;
        if (!isFormValid) {
            return;
        }
        controller.formSubmit();
    }
    const anchor = typeof document === 'undefined' ? null : document.querySelector(HOST_ANCHOR_SELECTOR);
    if (anchor) {
        rootVm.$mount(anchor as Element);
    }
}
